'use strict';exports.__esModule = true;exports.isUserCanPublish = exports.isUserAllowedToPublishPage = undefined;var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var isUserAllowedToPublishPage = exports.isUserAllowedToPublishPage = function isUserAllowedToPublishPage(userData, propertiesData) {
  var isAgent = (0, _get2.default)(userData, 'is_agent');
  var accessToken = (0, _get2.default)(userData, 'access_token');
  var activePropertiesCount = (0, _get2.default)(propertiesData, 'active') || 0;
  var allowedPropertiesCount = (0, _get2.default)(propertiesData, 'allowed') || 0;
  var propertiesCountUnderLimit = activePropertiesCount < allowedPropertiesCount;

  return !!(isAgent || !accessToken || propertiesCountUnderLimit && accessToken);
};

var isUserCanPublish = exports.isUserCanPublish = function isUserCanPublish() {var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var isAgent = arguments[1];var
  active = properties.active,allowed = properties.allowed,allowedUntil = properties.allowed_until;
  var hasAllowedProperties = active < allowed;

  if (isAgent) {
    return !allowedUntil || hasAllowedProperties && allowedUntil;
  }

  return hasAllowedProperties;
};


//////////////////
// WEBPACK FOOTER
// ./src/utils/checkUserIsAllowedToPublish.js
// module id = 590
// module chunks = 0